<template>
  <div :class="[name]" v-if="images.length" v-draggable="draggable" :style="coords">
    <div :class="['controls-box', 'm-1']">
      <div :ref="handleId" v-if="title" v-html="lang.layersPreview" :class="['inline-block', 'controls-box-title']" />
      <div :class="['p-1', 'controls-box-content']">
        <ul :class="['m-1']">
          <li
            v-for="(image, index) in images"
            :key="index" :class="['m-1', image.hidden ? 'image-hidden' : null, index === $root.selectedLayer ? null : 'cursor-pointer', index === $root.selectedLayer ? 'selected-layer' : null]"
            @click="selectLayer(image.index)">
            <icon name="eye-off" v-if="image.hidden" :font-size="2" />
            <img :src="image.url" :style="{filter: image.filtersString}" :title="image.index" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { Draggable } from 'draggable-vue-directive'
import methods from '../helpers/methods'
import lang from '../helpers/lang'

export default {
  name: 'LayersPreview',
  directives: {
    Draggable
  },
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      name: 'layers-preview',
      handleId: 'layers-preview-handle',
      draggable: {
        handle: undefined,
        boundingElement: document.querySelector('body'),
        onDragEnd: this.onDragEnd
      }
    }
  },
  props: {
    /**
     * Images array
     */
    images: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    this.draggable.handle = this.$refs[this.handleId]
  },
  computed: {
    /**
     * Get the top and left coordinates of the component from the local storage
     * @computed coords
     * @return {string}
     */
    coords () {
      const coords = this.getLocalData().layersPreviewCoords
      if (coords && coords.length) {
        return `top: ${coords[0]}px; left: ${coords[1]}px`
      }
    }
  },
  methods: {
    /**
     * Handler for the drag-end callback of the component
     * @computed onDragEnd
     * @return {void}
     */
    onDragEnd () {
      const element = document.querySelector(`.${this.name}`)
      const localData = this.getLocalData()
      localData.layersPreviewCoords = [element.offsetTop, element.offsetLeft]
      this.setLocalData(localData)
    }
  }
}
</script>
<style>
.layers-preview
{
  position: fixed;
  top: calc(100vh - (var(--em-8) * 5));
  left: calc(var(--em-8) * 2);
  z-index: 1000;
}

.layers-preview ul
{
  overflow: auto;
  white-space: nowrap;
  max-width: calc(74px * 5);
}

.layers-preview li
{
  display: inline-block;
  vertical-align: middle;
  border: solid 2px var(--darkest);
  position: relative;
}

.layers-preview img
{
  display: block;
  width: 64px;
}

.layers-preview .mdi
{
  position: absolute;
  z-index: 10;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: var(--red);
}

.layers-preview .selected-layer
{
  border-color: var(--white);
}

.layers-preview .image-hidden img
{
  filter: blur(var(--em-1));
}

.layers-preview .controls-box-title
{
  cursor: move;
}
</style>



// WEBPACK FOOTER //
// src/components/layers-preview.vue